// src/components/sidebar/Sidebar.jsx
import React, { useContext, useState, useImperativeHandle, forwardRef } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { userContext } from '../../context/ContextProvider';
import { logout } from '../../services/axiosConfig';
import { showNotification } from '../../utils/notification';
import './sidebar.css';
import { 
  ShieldCheck, 
  User,
  LayoutDashboard,
  Package,
  Warehouse,
  Tag,
  CreditCard,
  Users,
  TrendingUp,
  TrendingDown,
  LogOut
} from 'lucide-react';

const Sidebar = forwardRef(({ isOpen, title, navItems }, ref) => {
  const { user, setUser, setRole, setAuthenticated } = useContext(userContext);
  const navigate = useNavigate();
  
  const [isCollapsed, setIsCollapsed] = useState(false);

  // Expose toggleCollapse method to parent via ref
  useImperativeHandle(ref, () => ({
    toggleCollapse: () => {
      setIsCollapsed(prev => !prev);
    }
  }));

  const handleLogout = async () => {
    const confirmLogout = window.confirm('Are you sure you want to logout?');
    if (!confirmLogout) return;

    try {
      await logout();
      setUser(null);
      setRole('');
      setAuthenticated(false);
      showNotification('Logged out successfully', 'success');
      navigate('/login');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  const iconMap = {
    'Dashboard': LayoutDashboard,
    'Stock Management': Package,
    'Inventory': Warehouse,
    'Categories': Tag,
    'Cash Management': CreditCard,
    'Employees': Users,
    'Sales': TrendingUp,
    'Expenses': TrendingDown,
  };

  const items = Array.isArray(navItems) ? navItems : [];

  return (
    <aside className={`sidebar ${isOpen ? 'open' : ''} ${isCollapsed ? 'collapsed' : ''}`}>
      {/* Company Logo */}
      <div className="company-logo">
        {/* <ShieldCheck size={24} className="company-icon" /> */}
        {/* <span className="company-name">SAYUL ERP</span> */}
      </div>

      {/* Profile Section */}
      <div className="profile-section">
        <div className="profile-image">
          <User className="profile-icon" />
        </div>
        <div className="profile-info">
          <div className="profile-name">
            {user?.firstName || user?.name || 'Admin User'}
          </div>
          <div className="profile-role">
            {user?.role || 'Super Administrator'}
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="nav-list">
        {items.map((item, index) => {
          const IconComponent = iconMap[item.name] || Tag;
          
          return (
            <div key={index} className="nav-item">
              <NavLink
                to={item.path}
                className={({ isActive }) =>
                  `nav-link ${isActive ? 'active' : ''}`
                }
                title={isCollapsed ? item.name : ''}
              >
                <IconComponent className="nav-icon" size={20} />
                <span className="nav-text">{item.name}</span>
              </NavLink>
            </div>
          );
        })}
      </nav>

      {/* Logout Button */}
      <button 
        className="logout-btn" 
        onClick={handleLogout} 
        title={isCollapsed ? 'Logout' : ''}
      >
        <LogOut className="logout-icon" size={20} />
        <span className="logout-text">Logout</span>
      </button>
    </aside>
  );
});

Sidebar.displayName = 'Sidebar';

export default Sidebar;